import Login from '@/game/scenes/Login/Login';
import Paywall from '@/game/scenes/Paywall';
import Preloader from '@/game/scenes/Preloader';
import Level1 from '@/game/scenes/TilemapScenes/Level1';
import Level10 from '@/game/scenes/TilemapScenes/Level10';
import Level11 from '@/game/scenes/TilemapScenes/Level11';
import Level12 from '@/game/scenes/TilemapScenes/Level12';
import Level13 from '@/game/scenes/TilemapScenes/Level13';
import Level14 from '@/game/scenes/TilemapScenes/Level14';
import Level15 from '@/game/scenes/TilemapScenes/Level15';
import Level16 from '@/game/scenes/TilemapScenes/Level16';
import Level17 from '@/game/scenes/TilemapScenes/Level17';
import Level18 from '@/game/scenes/TilemapScenes/Level18';
import Level19 from '@/game/scenes/TilemapScenes/Level19';
import Level2 from '@/game/scenes/TilemapScenes/Level2';
import Level20 from '@/game/scenes/TilemapScenes/Level20';
import Level21 from '@/game/scenes/TilemapScenes/Level21';
import Level22 from '@/game/scenes/TilemapScenes/Level22';
import Level23 from '@/game/scenes/TilemapScenes/Level23';
import Level24 from '@/game/scenes/TilemapScenes/Level24';
import Level25 from '@/game/scenes/TilemapScenes/Level25';
import Level26 from '@/game/scenes/TilemapScenes/Level26';
import Level27 from '@/game/scenes/TilemapScenes/Level27';
import Level28 from '@/game/scenes/TilemapScenes/Level28';
import Level29 from '@/game/scenes/TilemapScenes/Level29';
import Level3 from '@/game/scenes/TilemapScenes/Level3';
import Level30 from '@/game/scenes/TilemapScenes/Level30';
import Level31 from '@/game/scenes/TilemapScenes/Level31';
import Level4 from '@/game/scenes/TilemapScenes/Level4';
import Level5 from '@/game/scenes/TilemapScenes/Level5';
import Level6 from '@/game/scenes/TilemapScenes/Level6';
import Level7 from '@/game/scenes/TilemapScenes/Level7';
import Level8 from '@/game/scenes/TilemapScenes/Level8';
import Level9 from '@/game/scenes/TilemapScenes/Level9';
import { Game } from 'phaser';
import AnchorPlugin from 'phaser3-rex-plugins/plugins/anchor-plugin.js';
import { Boot } from './Scenes/Init/Boot';
import { MainScene } from './Scenes/MainScene';

//  Find out more information about the Game Config at:
//  https://newdocs.phaser.io/docs/3.70.0/Phaser.Types.Core.GameConfig
export const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  backgroundColor: '#282c34',
  dom: {
    createContainer: true,
  },
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    parent: 'game-container',
    zoom: 1, // Size of game canvas = game size * zoom
    max: {
      width: 1600,
      height: 1024,
    },
    min: {
      width: 375,
      height: 375,
    },
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 }, // Neutralize gravity
      debug: false,
      width: 99999,
      height: 99999, // outrageous
    },
  },
  render: {
    antialias: true,
    antialiasGL: true,
    roundPixels: false,
    pixelArt: false,
  },
  plugins: {
    global: [
      {
        key: 'rexanchorplugin',
        plugin: AnchorPlugin,
        start: true,
      },
    ],
  },
  callbacks: {
    postBoot: function (game) {
      game.scene.dump();
    },
  },
  scene: [Boot, Login, Paywall, Preloader, MainScene],
};

const StartGame = (parent: string) => {
  return new Game({ ...config, parent });
};

// Add tilemap levels to this array as they are created.
export const TilemapLevels = [
  {
    key: 'Level1',
    scene: Level1,
    biome: 'forest',
  },
  {
    key: 'Level2',
    scene: Level2,
    biome: 'forest',
  },
  {
    key: 'Level3',
    scene: Level3,
    biome: 'forest',
  },
  {
    key: 'Level4',
    scene: Level4,
    biome: 'forest',
  },
  {
    key: 'Level5',
    scene: Level5,
    biome: 'forest',
  },
  {
    key: 'Level6',
    scene: Level6,
    biome: 'spring',
  },
  {
    key: 'Level7',
    scene: Level7,
    biome: 'spring',
  },
  {
    key: 'Level8',
    scene: Level8,
    biome: 'spring',
  },
  {
    key: 'Level9',
    scene: Level9,
    biome: 'spring',
  },
  {
    key: 'Level10',
    scene: Level10,
    biome: 'spring',
  },
  {
    key: 'Level11',
    scene: Level11,
    biome: 'desert',
  },
  {
    key: 'Level12',
    scene: Level12,
    biome: 'desert',
  },
  {
    key: 'Level13',
    scene: Level13,
    biome: 'desert',
  },
  {
    key: 'Level14',
    scene: Level14,
    biome: 'desert',
  },
  {
    key: 'Level15',
    scene: Level15,
    biome: 'desert',
  },
  {
    key: 'Level16',
    scene: Level16,
    biome: 'winter',
  },
  {
    key: 'Level17',
    scene: Level17,
    biome: 'winter',
  },
  {
    key: 'Level18',
    scene: Level18,
    biome: 'winter',
  },
  {
    key: 'Level19',
    scene: Level19,
    biome: 'winter',
  },
  {
    key: 'Level20',
    scene: Level20,
    biome: 'winter',
  },
  {
    key: 'Level21',
    scene: Level21,
    biome: 'tropical',
  },
  {
    key: 'Level22',
    scene: Level22,
    biome: 'tropical',
  },
  {
    key: 'Level23',
    scene: Level23,
    biome: 'tropical',
  },
  {
    key: 'Level24',
    scene: Level24,
    biome: 'tropical',
  },
  {
    key: 'Level25',
    scene: Level25,
    biome: 'tropical',
  },
  {
    key: 'Level26',
    scene: Level26,
    biome: 'forest',
  },
  {
    key: 'Level27',
    scene: Level27,
    biome: 'spring',
  },
  {
    key: 'Level28',
    scene: Level28,
    biome: 'forest',
  },
  {
    key: 'Level29',
    scene: Level29,
    biome: 'forest',
  },
  {
    key: 'Level30',
    scene: Level30,
    biome: 'spring',
  },
  {
    key: 'Level31',
    scene: Level31,
    biome: 'spring',
  },
];

export const MINIGAME_HEIGHT_BREAKPOINT = 768;

export default StartGame;
